export default __webpack_public_path__ + "static/media/affligem_xl3.af7ff421.png";